module.exports = __webpack_public_path__ + "img/4.37ca13f.svg";